import { TFunction } from 'i18next'
import z from 'zod'

import { getNDaysSchema } from './getNDaysSchema'

export const getAutomaticPaymentRemindersPostAfterDueDateSchema = (t: TFunction) =>
  z.object({
    nDays: getNDaysSchema(t),
    active: z.boolean(),
  })
